const datasets = [
  { value: 'world', display: '- World -', disabled: true },
  { value: 'countries', display: 'Countries' },
  { value: 'countriesWithFlags', display: 'Countries with Flags' },
  { value: 'usStates', display: 'US States' },
  { value: 'calendar', display: '- Calendar & Date -', disabled: true },
  { value: 'months', display: 'Months' },
  { value: 'years', display: 'Years' },
  { value: 'daysOfWeek', display: 'Days of Week' },
  { value: 'daysOfMonth', display: 'Days of Month' }
]

module.exports = datasets
